import React from "react";

const DeleteConfirmationModal = ({ onConfirm, onCancel, noteContent }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4 text-red-400">
          Delete This Note?
        </h2>
        <p className="mb-6 text-gray-300">
          Are you sure you want to delete this note?{" "}
          {noteContent && (
            <span className="text-gray-400 italic">
              "
              {noteContent.length > 50
                ? noteContent.substring(0, 50) + "..."
                : noteContent}
              "
            </span>
          )}
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Delete
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
